<template>
  <page-wrapper :title="title" :has-pad="true">
    <div class="row">
      <div class="col-5">
        <user-list v-model="users"></user-list>
      </div>
      <div class="col-7">
        <h4>ข้อความที่ต้องการส่ง</h4>
        <hr />
        <el-input v-model="message" class="message" type="textarea"></el-input>
        <div class="text-end mt-4">
          <sc-button variant="primary" @click="handleSubmit">บันทึก</sc-button>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { Input } from "element-ui";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import UserList from "../components/UserList";

export default {
  components: {
    PageWrapper,
    ScButton,
    ElInput: Input,
    UserList
  },
  data() {
    return {
      title: "ส่งข้อความ",
      users: [],
      message: ""
    };
  },
  methods: {
    async handleSubmit() {
      if (!this.users.length) {
        this.$message.error("กรุณาเลือกผู้รับข้อความ");
        return;
      }

      if (!this.message.trim()) {
        this.$message.error("กรุณาใส่ข้อความที่ต้องการส่ง");
        return;
      }

      const to = this.users.map(user => {
        const { id: userId, homeId, projectId } = user;

        return {
          userId,
          homeId,
          projectId
        };
      });

      const detail = this.message;
      const params = {
        to,
        detail
      };

      try {
        await baanRueJaiClient.admin.greeting.postSend(params);

        this.$message.success("ส่งข้อความเรียบร้อย");
        this.message = "";
        this.users = [];
      } catch (error) {
        this.$message.error("ไม่สามารถส่งข้อความได้");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
</style>
